import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IProduct } from '../../../../types/product';

export const FlashdealReorderDraggableComponent = ({ data }: { data: IProduct }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: data.iD,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: '10px 20px',
    margin: '5px 0',
    backgroundColor: '#FAFAFA',
    border: '1px solid #ccc',
    borderRadius: '5px',
    cursor: 'grab',
    boxShadow: isDragging ? '0 5px 15px rgba(0,0,0,0.3)' : 'none',
    opacity: isDragging ? 0.9 : 1,
    zIndex: isDragging ? 999 : 'auto', // ensure dragged item is on top
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {data.sKU} - {data.name}
    </div>
  );
};
